import * as React from 'react';
import { cn } from './utils';

function Card({ className, ...props }) {
  return (
    <div
      data-slot="card"
      className={cn('bg-card text-card-foreground flex flex-col gap-6 rounded-xl border', className)}
      {...props}
    />
  );
}

export { Card };
